export enum SpectrumQueryKey {
  Product = 'p',
  LightSpectrum = 'l',
  AbsorptionSpectrum = 'a',
  Weight = 'w',
  FancyGreyStrength = 'fg',

  ComparatorProduct = 'c_p',
  ComparatorLightSpectrum = 'c_l',
  ComparatorAbsorptionSpectrum = 'c_a',
  ComparatorWeight = 'c_w',
  ComparatorFancyGreyStrength = 'c_fg',

  LensFValue = 'f',
  CarbonViewerVersion = 'cv',
  CarbonViewerBranch = 'cvb',
  PixelRatio = 'pr',
  Camera = 'cam',
  Debug = 'debug',
  Compare = 'compare',
  Develop = 'dev',
}
